import { CONTRATO } from '../../../../constants/tipoContrato';

const CONTRATOS_TEMPORALES = [CONTRATO.TERMINO_FIJO, CONTRATO.OPS];

/**
 * Calcula campos derivados (Disponible, Bloqueado, Embargo).
 * @returns {Object} Nuevos estados.
 */
export const calcularEstadoEmpleado = (
  empleado,
  fechaIngreso,
  fechaHasta,
  fechaActual
) => {
  const esEmbargado = determinarSiEstaEmbargado(empleado.Embargo);

  return {
    Disponible: calcularDisponibilidad(
      empleado.TipoContrato,
      fechaIngreso,
      fechaHasta,
      fechaActual
    ),
    Embargo: esEmbargado,
    Bloqueado: esEmbargado,
  };
};

const determinarSiEstaEmbargado = valorEmbargo => {
  if (typeof valorEmbargo === 'boolean') return valorEmbargo;
  return valorEmbargo === 1 || valorEmbargo === 'Sí';
};

const calcularDisponibilidad = (
  tipoContrato,
  fechaIngreso,
  fechaHasta,
  fechaActual
) => {
  if (!fechaIngreso.isValid()) return false;

  const tieneAntiguedadSuficiente = fechaIngreso
    .clone()
    .add(1, 'days')
    .isBefore(fechaActual.clone().subtract(6, 'months'));

  if (!tieneAntiguedadSuficiente) return false;

  const esContratoTemporal = CONTRATOS_TEMPORALES.includes(tipoContrato);
  if (esContratoTemporal && fechaHasta.isValid()) {
    const vencePronto = fechaHasta.isBefore(
      fechaActual.clone().add(1, 'month')
    );
    if (vencePronto) return false;
  }

  return true;
};
